/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useQuery } from 'react-query'

import { getHistoryV1 } from '@modules/billing-api/v1/callers'
import type { QueryHook, QueryHookOptions } from '@modules/query/types'

import { defaultBillingOptions } from './constants'

// TODO: update this type once the API is fixed to return correct types
export type BillingHistory = {
  invoices: Awaited<ReturnType<typeof getHistoryV1>>['invoices']
  statements: Array<
    Awaited<ReturnType<typeof getHistoryV1>>['statements'][number] & { reseller: boolean }
  >
}

const useGetBillingHistory: QueryHook<typeof getHistoryV1> = (
  organizationId: string,
  options?: QueryHookOptions,
) =>
  useQuery(
    [`getHistoryV1`, organizationId],
    () => getHistoryV1({ pathParameters: { organization_id: organizationId } }),
    {
      ...defaultBillingOptions,
      ...options,
      enabled: Boolean(organizationId),
    },
  )

export default useGetBillingHistory
